var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.9082C6.97715 22.9082 2.5 18.431 2.5 12.9082C2.5 7.38535 6.97715 2.9082 12.5 2.9082C18.0228 2.9082 22.5 7.38535 22.5 12.9082C22.5 18.431 18.0228 22.9082 12.5 22.9082ZM12.5 20.9082C16.9183 20.9082 20.5 17.3265 20.5 12.9082C20.5 8.48992 16.9183 4.9082 12.5 4.9082C8.08172 4.9082 4.5 8.48992 4.5 12.9082C4.5 17.3265 8.08172 20.9082 12.5 20.9082ZM13.5 12.9082H17.5V14.9082H11.5V7.9082H13.5V12.9082Z",
    fill: "#FB5C52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.bd9bdfb9aab9653e9db28b96bd0b04cc.svg";
export { ForwardRef as ReactComponent };